/* eslint-disable prettier/prettier */
/* eslint-disable no-console */
import React, { createContext, useEffect, useState } from 'react';
import { getStoreDetailByNumber } from '../api/user';
export const FeatureFlagContext = createContext<any>('');
export function FeatureFlagContextProvider(props: any) {
    const [fieldDeviceParamKey, setfieldDeviceParamKey] = useState('');
    const [pilotStoreParamKey, setpilotStoreParamKey] = useState('')
    const [upcomingDapParamKey, setUpcomingDapParamKey] = useState('');
    const [taskandGoals, setTaskandGoals] = useState('')
    const [customerSurveyParamKey, setCustomerSurveyParamKey] = useState('')
    const [updateRecieptKey, setUpdateRecieptKey] = useState(null)
    const [customerVerification, setCustomerVerification] = useState('');
    const [enableWebLeadDeposit, setEnableWebleadDeposit] = useState<boolean>(false);
    const [emailRestrictedVerificationLevels,setEmailRestrictedVerificationLevels]=useState('')
    const [MXStoreIdentifier,setMXStoreIdentifier]= useState<boolean>(false)
    const [addressVerificationSurveyParamKey, setAddressVerificationSurveyParamKey] = useState("");
    const [enableDocumentsCheck, setEnableDocumentsCheck] = useState<string>("");
    const [enablecountrycode, setEnablecountrycode] = useState(0);
    const [enableLivelinessCheck, setEnableLivelinessCheck] = useState("");
    const [enableManualSelfieUpload, setEnableManualSelfieUpload] = useState("");
    const [enableCallCenterLivenessAuth, setEnableCallCenterLivenessAuth] = useState("");
    const [dateTimeLocalization, setDateTimeLocalization] = useState();
    const [countryIdentification, setCountryIdentification] = useState('');
    const [EnableRAFSurvey, setEnableRAFSurvey] = useState('');
    const [localSourceRamp, setLocalSourceRamp] = useState('');
    const [storeActionItemRedesignParamKey, setStoreActionItemRedesignParamKey] = useState('');

    useEffect(() => {
   const fetchcountryDetails = async (storeNumber: string) => {
    try {
      const details = await getStoreDetailByNumber(storeNumber);
      const country = details?.response[0]?.countryAbb?.toString().toUpperCase?.();
      setCountryIdentification(country || '');
    } catch (error: any) {
      console.log('something went wrong', error);
    }
  };

  const fetchStoreDetails = async () => {
    const storeDetails = sessionStorage.getItem('storeDetails');
    if (storeDetails) {
      try {
        const decoded = Buffer.from(storeDetails, 'base64').toString('utf8');
        const parsed = JSON.parse(decoded);
        const country = parsed?.country?.toString().toUpperCase();
        setCountryIdentification(country || '');
        return; 
      } catch (error: any) {
      console.log('something went wrong', error);
    }
    }
    else{
       const storeNumber = sessionStorage.getItem('storeNumber');
        if (!storeNumber) {
          return;
        }
       await fetchcountryDetails(storeNumber);
    }
  };
  fetchStoreDetails();
}, []);
    return (
        <div>
            <FeatureFlagContext.Provider
                value={{
                    fieldDeviceParamKey,
                    setfieldDeviceParamKey,
                    pilotStoreParamKey,
                    setpilotStoreParamKey,
                    updateRecieptKey,
                    setUpdateRecieptKey,
                    upcomingDapParamKey,
                    setUpcomingDapParamKey,
                    taskandGoals,
                    setTaskandGoals,
                    customerSurveyParamKey,
                    setCustomerSurveyParamKey,
                    customerVerification,
                    setCustomerVerification,
                    enableWebLeadDeposit,
                    setEnableWebleadDeposit,
                    setEmailRestrictedVerificationLevels,
                    emailRestrictedVerificationLevels,
                    MXStoreIdentifier,
                    setMXStoreIdentifier,
                    addressVerificationSurveyParamKey,
                    setAddressVerificationSurveyParamKey,
                    enableDocumentsCheck,
                    setEnableDocumentsCheck,
                    enablecountrycode,
                    setEnablecountrycode,
                    dateTimeLocalization,
                    setDateTimeLocalization,
                    countryIdentification,
                    enableLivelinessCheck, setEnableLivelinessCheck,
                    enableManualSelfieUpload, setEnableManualSelfieUpload,
                    enableCallCenterLivenessAuth, setEnableCallCenterLivenessAuth,
                    EnableRAFSurvey, setEnableRAFSurvey,
                    storeActionItemRedesignParamKey, setStoreActionItemRedesignParamKey,
                    localSourceRamp, setLocalSourceRamp
                }}
            >
                {props.children}
            </FeatureFlagContext.Provider>
        </div>
    );
}
